module.exports = __webpack_public_path__ + "img/activity_42.59ddbd66.jpg";